/**
 *
 */
import { get, post, put } from 'mdoc/admin/axios/tools'
import * as config from 'mdoc/admin/axios/config'

/**
 * check 名称是否存在
 */
export const checkDepartmentName = (param) => new Promise((resolve, reject) => {
    get(config.DEPARTMENT_CHECK, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve({ results: response })
            }
        }).catch(function (error) {
            reject(error);
        })
}
);

/**
 * 添加分类
 */
export const addDepartment = (param) => new Promise((resolve, reject) => {
    post(config.DEPARTMENT_ADD, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage)
            } else {
                resolve({ results: response })
            }
        }).catch(function (error) {
            reject(error);
        })
}
);

/**
 * 删除分类
 */
export const deleteDepartmentById = (param) => new Promise((resolve, reject) => {
    get(config.DEPARTMENT_DELETE, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage)
            } else {
                resolve({ results: response })
            }
        }).catch(function (error) {
            reject(error);
        })
}
);

/**
 * 修改分类
 */
export const updateDepartmentById = (param) => new Promise((resolve, reject) => {
    put(config.DEPARTMENT_UPDATA, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage)
            } else {
                resolve({ results: response })
            }
        }).catch(function (error) {
            reject(error);
        })
}
);

/**
 * 修改排序
 */
export const updateDepartmentSequence = (param) => new Promise((resolve, reject) => {
    put(config.DEPARTMENT_CHANGE, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage)
            } else {
                resolve({ results: response })
            }
        }).catch(function (error) {
            reject(error);
        })
}
);